import { Loader, Button, Alert } from 'rsuite';
import { Avatar, TextField, Typography } from '@material-ui/core';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import loginService from '../../../services/login';
import React, { useEffect, useState } from 'react';

export default function Verify () {
    const { token } = useParams();
    const history = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const idExternal = query.get('_');
    //
    // State
    //
    // Verifying state
    const [verifying, setVerifying] = useState(false);

    // Password state
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Validation state
    const [validateUserId, setValidateUserId] = useState();

    //
    // Functions
    //

    const validateUser = () => {
        // loginService
        const data = {
            idPlatform: 5,
            email: 'no-reply@backoffice.com',
            token,
            idExternal
        };

        return loginService
            .validate(data)
            .then(response => {
                setValidateUserId(Number(response.metadata.metadata.user.id));
                setVerifying(false);
                Alert.success('El usuario fue validado correctamente. Por Favor, ingrese su nueva contraseña.', 5000);
            })
            .catch(e => {
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                console.error(e);
            });
    };

    const changePassword = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!validate()) {
            setIsLoading(false);
            return false;
        }

        const data = {
            idPlatform: 5,
            idUser: validateUserId,
            password: password,
            token: token,
            idToken: idExternal
        };

        return loginService
            .change(data)
            .then(response => {
                Alert.success('Su nueva contraseña fue creada exitosamente.', 5000);
                setIsLoading(false);
                history.push('/auth/login');
            })
            .catch(e => {
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                console.error(e);
                setIsLoading(false);
            });
    };

    const validate = () => {
        if (password !== confirmPassword) {
            Alert.warning('Las Contraseña no coinciden.', 5000);
            return false;
        }

        const hasLower = new RegExp('^(?=.*[a-z])');
        const hasUpper = new RegExp('^(?=.*[A-Z])');
        const hasNum = new RegExp('^(?=.*[0-9])');
        const hasSpecial = new RegExp('^(?=.*[-+!@#$%^&*])');
        const hasLength = new RegExp('^(?=.{8,})');

        if (!hasLower.test(password)) {
            Alert.warning('La Contraseña debe contener minimamente un caracter en minuscula.', 5000);
            return false;
        }
        if (!hasUpper.test(password)) {
            Alert.warning('La Contraseña debe contener minimamente un caracter en mayuscula.', 5000);
            return false;
        }
        if (!hasNum.test(password)) {
            Alert.warning('La Contraseña debe contener minimamente un numero.', 5000);
            return false;
        }
        if (!hasSpecial.test(password)) {
            Alert.warning('La Contraseña debe contener minimamente un caracter especial.', 5000);
            return false;
        }
        if (!hasLength.test(password)) {
            Alert.warning('La Contraseña debe contener minimamente una longitud mayor a 8 caracteres.', 5000);
            return false;
        }
        return true;
    };

    //
    // UseEffect
    //
    useEffect(() => {
        // Validate user using token and password
        validateUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (verifying) {
        return (
            <div className='auth-page'>
                <h1>Verificando...</h1>
                <Loader size='lg' />
            </div>
        );
    }

    return (
        <div className='auth-page'>
            <Avatar>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Cree una nueva contraseña
            </Typography>
            <form noValidate onSubmit={changePassword}>
                <TextField
                    id="password"
                    label="Nueva Contraseña"
                    name="password"
                    variant="outlined"
                    type="password"
                    autoFocus fullWidth
                    onChange={(event) => setPassword(event.target.value)}
                />
                <TextField
                    id="password-confirm"
                    label="Confirme Contraseña"
                    name="password-confirm"
                    variant="outlined"
                    type="password"
                    fullWidth
                    onChange={(event) => setConfirmPassword(event.target.value)}
                />
                <Button
                    type="submit"
                    appearance='primary'
                    loading={isLoading}
                    block
                >
                    Aceptar
                </Button>
            </form>
        </div>
    );
};
